import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { HttpApiService } from '@app/providers/http-api/http-api.service';

/* fix google name space issue hack */
// import {} from '@types/googlemaps';

@Component({
    selector: 'pro-auto-location',
    templateUrl: './auto-location.component.html',
    styleUrls: ['./auto-location.component.scss'],
    standalone: false
})
export class AutoLocationComponent implements OnInit {
  @Input() userId: any;
  @Input() address: any;
  @Input() rent: any;
  @Input() countries: any;
  @Output() response: any = new EventEmitter();

  @ViewChild('searchInput', { static: true })
  public searchElementRef: ElementRef;

  isRp: boolean;

  /**
    situation: OWNER / TENANT / HOSTED / UNKNOW
    */
  mainAddress: any = {
    id: null,
    isRp: null,
    street: '',
    zipCode: '',
    city: '',
    propertyAreaSize: null,
    propertyType: 'APPARTMENT',
    country: '',
    situation: 'TENANT',
    isMain: true,
    isCurrent: true,
  };

  constructor(
    private ngZone: NgZone,
    private _http: HttpApiService,
  ) {}

  ngOnInit() {
    if (this.address) {
      this.mainAddress = this.address;
      if (this.mainAddress.situation === 'UNKNOW') {
        this.mainAddress.situation = 'TENANT';
      }

      if (this.mainAddress.propertyType == null) {
        this.mainAddress.propertyType = 'APPARTMENT';
      }

      this.mainAddress.isCurrent = true;
      this.isRp = this.mainAddress.isRp ? true : false;
    }

    this.loadGMAutoPlaces();
  }

  /* Google maps auto places */
  loadGMAutoPlaces() {
    // load Places Autocomplete
    let autocomplete = new google.maps.places.Autocomplete(
      this.searchElementRef.nativeElement,
      {
        types: ['address'],
      },
    );
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        // get the place result
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        // verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        this.formatAddress(place);
        this.postAddress();
      });
    });
  }

  formatAddress(place: any): any {
    let componentForm = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      country: 'short_name',
      postal_code: 'short_name',
    };

    for (let i = 0; i < place.address_components.length; i++) {
      let addressType = place.address_components[i].types[0];
      let val = place.address_components[i][componentForm[addressType]];
      if (addressType === 'street_number') {
        this.mainAddress.street = val;
      }
      if (addressType === 'route') {
        this.mainAddress.street = this.mainAddress.street + ' ' + val;
      }
      if (addressType === 'postal_code') {
        this.mainAddress.zipCode = val;
      }
      if (addressType === 'locality') {
        this.mainAddress.city = val;
      }
      if (addressType === 'country') {
        this.mainAddress.country = val;
      }
    }
  }

  onAddressChange(event: any): void {
    let name = event.target.name,
      value = event.target.value;
    if (
      this.mainAddress.hasOwnProperty(name) &&
      value !== this.mainAddress[name]
    ) {
      this.mainAddress[name] = value;
      this.postAddress();
    }
  }

  onIsRpChange(event: any): void {
    this.isRp = !this.isRp;
    this.mainAddress['isRp'] = this.isRp;
    this.postAddress();
  }

  postAddress(): void {
    this._http.post(`/user/${this.userId}/address`, this.mainAddress).subscribe(
      res => {
        this.response.emit({ status: 'ok', type: 'ADDRESS' });
      },
      err => {
        this.response.emit({ status: 'error', type: 'ADDRESS' });
      },
    );
  }

  postExpense(body: any): void {
    this._http.post(`/user/${this.userId}/expense`, body).subscribe(
      res => {
        this.response.emit({ status: 'ok', type: 'RENT' });
      },
      err => {
        this.response.emit({ status: 'error', type: 'RENT' });
      },
    );
  }

  onUpdateExpense(event: any): void {
    let name = event.target.name;
    let value = Number(event.target.value);

    if (value) {
      if (this.rent) {
        if (this.rent['amount'] !== value) {
          this.rent[name] = value;
          this.postExpense(this.rent);
        }
      } else {
        let body = {
          id: null,
          frequency: 'MENS',
          isCurrent: true,
          amount: value,
          type: 'RENT',
        };
        this.postExpense(body);
      }
    }
  }
}
